import React from "react";
import { useState } from "react";
import { showToast } from "./Toast";
import parse from "html-react-parser";
import { countryCodes } from "../../Constant";
import AxiosInstance from "../../services/AxiosInstance";
import { SYSTEM_PREFIX, COINS } from "../../Constant/index";
// Capitalize function

export const showStyledCoins = (postJobPoints) => {
  return (
    <strong className="text-success">
      {postJobPoints} {COINS}
    </strong>
  );
};

export const styleTotalCoins = (postJobPoints) => {
  return <strong className="text-primary">{postJobPoints}</strong>;
};

export const getFileExtension = (url) => {
  return url.split(".").pop().split(/\#|\?/)[0];
};

export const sanitizedFileName = (candidateName) => {
  return candidateName.replace(/\s+/g, "_");
};

/** Copy plain text to the clipboard (Clipboard API with textarea fallback). */
export const copyTextToClipboard = async (text) => {
  if (text == null || String(text) === "") {
    return false;
  }
  const value = String(text);
  try {
    if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch (e) {
    /* fall through */
  }
  try {
    const ta = document.createElement("textarea");
    ta.value = value;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.left = "-9999px";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch (e) {
    return false;
  }
};

export const getFileType = (fileExtension) => {
  const fileTypes = {
    pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  };
  return fileTypes[fileExtension.toLowerCase()] || "application/octet-stream";
};

export const downloadFileFromUrl = async (url, fileName) => {
  console.log("Fetching file from:", url, "with filename:", fileName);

  try {
    const response = await AxiosInstance().post(
      "/file/download",
      {
        fileUrl: url,
      },
      {
        responseType: "blob", // Ensure the response is handled as a blob
      }
    );

    if (response.status !== 200) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = response.data;
    const fileExtension = getFileExtension(url);
    const fileType = getFileType(fileExtension);

    const fileBlob = new Blob([blob], { type: fileType });

    // Create a temporary URL for the Blob object
    const tempUrl = URL.createObjectURL(fileBlob);

    // Create a temporary anchor element
    const anchor = document.createElement("a");
    anchor.href = tempUrl;
    anchor.download = SYSTEM_PREFIX + "_" + fileName + "_Resume";

    // Trigger the download by simulating a click on the anchor element
    document.body.appendChild(anchor);
    anchor.click();

    // Clean up the temporary URL
    URL.revokeObjectURL(tempUrl);
    document.body.removeChild(anchor);
  } catch (error) {
    console.error("Error fetching file:", error);
  }
};

export const capitalize = (str) => {
  if (typeof str !== "string") return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

// Date format function

export const formatDate = (inputDate) => {
  const inputDateObject = new Date(inputDate);
  const day = inputDateObject.getDate();
  const month = new Intl.DateTimeFormat("en-US", { month: "short" }).format(
    inputDateObject
  );
  const year = inputDateObject.getFullYear();

  return `${day} ${month} ${year}`;
};

export const formatToInteger = (number) => {
  return Math.floor(number);
};

// Search by input on change function

export const SearchComponent = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleInputChange = (event) => {
    setSearchTerm(event.list_name);

    console.log("Searching for:", searchTerm);
  };

  return (
    <div>
      <input value={searchTerm} onChange={handleInputChange} />
    </div>
  );
};

const CommonFunction = () => {
  return <div></div>;
};

export const handleCopyToClipboard = (value) => {
  return navigator.clipboard.writeText(value).then(
    () => {
      showToast("success", "Copied to clipboard");
    },
    (error) => {
      showToast("error", "Failed to copy");
      console.error("Failed to copy:", error);
    }
  );
};

export const handleSendEmail = (emailAddress) => {
  window.location.href = `mailto:${emailAddress}`;
};

export const handlePhoneCall = (phoneNumber) => {
  window.location.href = `tel:${phoneNumber}`;
};

// utils.js or within your component file
export const capitalizeEachWord = (text) => {
  if (!text) return "";

  return text
    .split(" ")
    .map((word) => word.toUpperCase())
    .join(" ");
};

export function unslugAndCapitalize(slug) {
  // Split the slug into an array of words
  const words = slug.split("_");

  // Capitalize the first letter of each word and keep the rest lowercase
  const capitalizedWords = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  );

  // Join the capitalized words back into a string
  const capitalizedText = capitalizedWords.join(" ");

  return capitalizedText;
}

export function capitalizeFirstLetter(text) {
  // Split the string into words based on spaces
  const words = text.split(" ");

  // Capitalize the first letter of each word and keep the rest lowercase
  const capitalizedWords = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  );

  // Join the capitalized words back into a string
  return capitalizedWords.join(" ");
}

// Time ago function
// export const timeAgo = (postDate) => {
//   const now = new Date();
//   const posted = new Date(postDate);

//   const seconds = Math.floor((now - posted) / 1000);
//   const minutes = Math.floor(seconds / 60);
//   const hours = Math.floor(minutes / 60);

//   let timeAgo;

//   if (seconds < 60) {
//     timeAgo = `${seconds} seconds ago`;
//   } else if (minutes < 60) {
//     timeAgo = `${minutes} minutes ago`;
//   } else if (hours < 24) {
//     timeAgo = `${hours} hours ago`;
//   } else {
//     const days = Math.floor(hours / 24);
//     const weeks = Math.floor(days / 7);
//     const months = Math.floor(days / 30);
//     const years = Math.floor(months / 12);

//     if (years > 0) {
//       timeAgo = `${years} years ago`;
//     } else if (months > 0) {
//       timeAgo = `${months} months ago`;
//     } else if (weeks > 0) {
//       timeAgo = `${weeks} weeks ago`;
//     } else {
//       timeAgo = `${days} days ago`;
//     }
//   }

//   return timeAgo;
// };

export const countWords = (str) => {
  if (!str || str.trim() === '') return 0;
  return str.trim().split(/\s+/).filter(word => word.length > 0).length;
};

export const timeAgo = (postDate, useAgo = true) => {
  const now = new Date();
  const posted = new Date(postDate);

  const seconds = Math.floor((now - posted) / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  let timeAgo;

  if (seconds < 60) {
    timeAgo = useAgo ? `${seconds} second${seconds !== 1 ? 's' : ''} ago` : `${seconds} second${seconds !== 1 ? 's' : ''}`;
  } else if (minutes < 60) {
    timeAgo = useAgo ? `${minutes} minute${minutes !== 1 ? 's' : ''} ago` : `${minutes} minute${minutes !== 1 ? 's' : ''}`;
  } else if (hours < 24) {
    timeAgo = useAgo ? `${hours} hour${hours !== 1 ? 's' : ''} ago` : `${hours} hour${hours !== 1 ? 's' : ''}`;
  } else {
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(months / 12);

    if (years > 0) {
      timeAgo = useAgo ? `${years} year${years !== 1 ? 's' : ''} ago` : `${years} year${years !== 1 ? 's' : ''}`;
    } else if (months > 0) {
      timeAgo = useAgo ? `${months} month${months !== 1 ? 's' : ''} ago` : `${months} month${months !== 1 ? 's' : ''}`;
    } else if (weeks > 0) {
      timeAgo = useAgo ? `${weeks} week${weeks !== 1 ? 's' : ''} ago` : `${weeks} week${weeks !== 1 ? 's' : ''}`;
    } else {
      timeAgo = useAgo ? `${days} day${days !== 1 ? 's' : ''} ago` : `${days} day${days !== 1 ? 's' : ''}`;
    }
  }

  return timeAgo;
};

// Function to format experience based on min and max values
// export const formatExperience = (minExperience, maxExperience) => {
//   if (minExperience !== "" && maxExperience !== "") {
//     const experienceMin = parseFloat(minExperience);
//     const experienceMax = parseFloat(maxExperience);

//     if (experienceMin === experienceMax) {
//       if (experienceMax === 1) {
//         return "1 year";
//       } else if (experienceMax === 0) {
//         return "0 year";
//       } else {
//         return `${experienceMax} years`;
//       }
//     } else {
//       return `${experienceMin} - ${experienceMax} years`;
//     }
//   } else if (maxExperience === "" || maxExperience === undefined) {
//     console.log("formatExperience");
//     if (minExperience <= 1) {
//       return `${minExperience} year`;
//     } else {
//       return `${minExperience} years`;
//     }
//   } else {
//     return "-";
//   }
// };

// Function to format timestamp to display in AM/PM format
export const formatTimeAMPM = (timestamp) => {
  const date = new Date(timestamp);
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // Handle midnight (0 hours)
  minutes = minutes < 10 ? "0" + minutes : minutes; // Add leading zero to minutes if needed
  const formattedTime = hours + ":" + minutes + " " + ampm;
  return formattedTime;
};

export const removeHTMLTags = (htmlString) => {
  const doc = new DOMParser().parseFromString(htmlString, "text/html");
  return doc.body.textContent || "";
};

export const parseHtmlBenefits = (benefitsStr, benefitsOptions) => {
  if (!benefitsStr || typeof benefitsStr !== "string") return [];

  // Check if it's HTML format (contains <tags>)
  const hasHtmlTags = /<[a-z][\s\S]*>/i.test(benefitsStr);
  if (hasHtmlTags) {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(benefitsStr, "text/html");
      const spans = doc.querySelectorAll("span");
      if (spans.length > 0) {
        return Array.from(spans)
          .map((span) => span.textContent.trim())
          .filter((text) => text.length > 0);
      }
      const lis = doc.querySelectorAll("li");
      if (lis.length > 0) {
        return Array.from(lis)
          .map((li) => li.textContent.trim())
          .filter((text) => text.length > 0);
      }
      const bodyText = doc.body.textContent || "";
      if (bodyText.trim()) {
        return bodyText
          .split(/[,\n]/)
          .map((s) => s.trim())
          .filter((s) => s.length > 0);
      }
    } catch (e) {
      console.error("Error parsing benefits HTML:", e);
    }
    return []; // Prevent fall-through if it was HTML
  }

  // Fallback / legacy parsing using benefitsOptions
  // Since it might be a comma-separated list of IDs: "1,2,3"
  const identifiers = benefitsStr.split(",");
  const parsed = [];
  for (const id of identifiers) {
    const trimmedId = id.trim();
    if (!trimmedId) continue;

    // Look up in benefitsOptions if possible
    const benefitOption = benefitsOptions?.find((option) => String(option.value) === trimmedId);
    if (benefitOption) {
      parsed.push(benefitOption.label);
    } else {
      // If it's a raw text benefit (not a numeric ID)
      parsed.push(trimmedId);
    }
  }
  return parsed;
};

// Function to convert HTML string to JSX
export function convertHtmlToJsx(htmlString) {
  // Parse the HTML string into JSX
  const jsx = parse(htmlString);

  return jsx;
}

// // Function to format individual salary number into "Lacs PA" format
// export function formatSalary(salary) {
//   if (salary < 100000) {
//     return (salary / 1000).toFixed(2).replace(/\.0+$/, "") + " K"; // Convert to fractional Lacs
//   } else if (salary < 10000000) {
//     return (salary / 100000).toFixed(2).replace(/\.0+$/, "") + " Lacs P.A."; // Convert to Lacs format with PA
//   } else {
//     return (salary / 10000000).toFixed(2).replace(/\.0+$/, "") + " Crores P.A."; // Convert to Crores format with PA
//   }
// }

// // Main function to format salary range output
// export const formatSalaryOutput = (salary_min, salary_max) => {
//   if (salary_min === undefined && salary_max === undefined) {
//     return "N/A"; // Return "N/A" if both minimum and maximum salaries are undefined
//   } else if (salary_min !== null && salary_max !== null) {
//     console.log("archana", formatSalary(salary_min));
//     const formatted_min = formatSalary(salary_min); // Format minimum salary
//     const formatted_max = formatSalary(salary_max); // Format maximum salary
//     return `${formatted_min.split(" ")[0]}-${
//       formatted_max.split(" ")[0]
//     } Lacs P.A.`; // Return formatted range string
//   } else if (salary_min !== null && salary_max === null) {
//     return `${formatSalary(salary_min)}`; // Return formatted minimum salary if no maximum
//   } else if (salary_min === null && salary_max !== null) {
//     return `${formatSalary(salary_max)}`; // Return formatted maximum salary if no minimum
//   } else {
//     return "N/A"; // Default case (should ideally not be reached)
//   }
// };

// Function to format individual salary number into "Lacs PA" format
export function formatSalary(salary) {
  if (salary === null || salary === undefined || salary === "") return "N/A";
  const num = Number(salary);
  if (isNaN(num)) return "N/A";
  if (num < 100000) {
    return (num / 1000).toFixed(2).replace(/\.0+$/, "") + " K"; // Convert to K
  } else if (num < 10000000) {
    return (num / 100000).toFixed(2).replace(/\.0+$/, "") + " Lacs P.A."; // Convert to Lacs format with PA
  } else {
    return (num / 10000000).toFixed(2).replace(/\.0+$/, "") + " Crores P.A."; // Convert to Crores format with PA
  }
}

// Main function to format salary range output
export const formatSalaryOutput = (salary_min, salary_max) => {
  const isInvalid = (v) => v === undefined || v === null || v === "";
  if (isInvalid(salary_min) && isInvalid(salary_max)) {
    return "N/A"; // Return "N/A" if both minimum and maximum salaries are undefined
  } else if (!isInvalid(salary_min) && !isInvalid(salary_max)) {
    const numMin = Number(salary_min);
    const numMax = Number(salary_max);
    if (!isNaN(numMin) && !isNaN(numMax) && numMin === numMax) {
      return formatSalary(salary_max);
    }

    const formatted_max = formatSalary(salary_max); // Format maximum salary
    const firstSpaceIndex = formatted_max.indexOf(" ");
    const max_num_str = firstSpaceIndex !== -1 ? formatted_max.substring(0, firstSpaceIndex) : formatted_max;
    const max_unit = firstSpaceIndex !== -1 ? formatted_max.substring(firstSpaceIndex + 1) : "";

    // Function to format salary based on the unit of the maximum salary
    const formatSalaryWithUnit = (salary, unit) => {
      const num = Number(salary);
      if (isNaN(num)) return "";
      if (unit.startsWith("K")) {
        return (num / 1000).toFixed(2).replace(/\.0+$/, "") + " " + unit;
      } else if (unit.startsWith("Lacs")) {
        return (num / 100000).toFixed(2).replace(/\.0+$/, "") + " " + unit;
      } else if (unit.startsWith("Crores")) {
        return (num / 10000000).toFixed(2).replace(/\.0+$/, "") + " " + unit;
      }
      return formatSalary(salary);
    };

    const formatted_min = formatSalaryWithUnit(salary_min, max_unit); // Format minimum salary using the same unit as maximum salary
    const minFirstSpace = formatted_min.indexOf(" ");
    const min_num_str = minFirstSpace !== -1 ? formatted_min.substring(0, minFirstSpace) : formatted_min;

    if (min_num_str === max_num_str) {
      return formatted_max;
    }

    return `${min_num_str}-${max_num_str}${max_unit ? " " + max_unit : ""}`; // Return formatted range string
  } else if (!isInvalid(salary_min) && isInvalid(salary_max)) {
    return formatSalary(salary_min); // Return formatted minimum salary if no maximum
  } else if (isInvalid(salary_min) && !isInvalid(salary_max)) {
    return formatSalary(salary_max); // Return formatted maximum salary if no minimum
  } else {
    return "N/A"; // Default case
  }
};

/** True if at least one salary bound is a finite number > 0 (handles string "0" from API). */
export const hasPositiveSalaryRange = (salary_min, salary_max) => {
  const toNum = (v) => {
    if (v === null || v === undefined || v === "") {
      return 0;
    }
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };
  const a = toNum(salary_min);
  const b = toNum(salary_max);
  return a > 0 || b > 0;
};

// // Function to format work experience output
// export const formatExperienceOutput = (minExp, maxExp) => {
//   if (minExp == "" && maxExp == "") {
//     return "N/A";
//   }else if (minExp == 0 && maxExp ==0) {
//     return 0 year;
//   } else if (minExp && maxExp) {
//     return minExp === maxExp
//       ? minExp <= 1
//         ? ${minExp} year
//         : ${minExp} years
//       : ${minExp}-${maxExp} years;
//   } else if (minExp && !maxExp) {
//     return minExp <= 1 ? ${minExp} year : ${minExp} years;
//   }
// };
export const formatExperienceOutput = (minExp, maxExp) => {
  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  // Check if both minExp and maxExp are 0 (or string "0")
  const isZeroValue = (value) => value === 0 || value === "0";
  if (isZeroValue(minExp) && isZeroValue(maxExp)) {
    return "Fresher";
  }

  if (!minExp && !maxExp) {
    return "";
  } else if (minExp && maxExp) {
    const output =
      minExp === maxExp
        ? minExp <= 1
          ? `${minExp} Year`
          : `${minExp} Years`
        : `${minExp}-${maxExp} Years`;
    return capitalizeFirstLetter(output);
  } else if (minExp && !maxExp) {
    const output = minExp <= 1 ? `${minExp} Year` : `${minExp} Years`;
    return capitalizeFirstLetter(output);
  } else if (!minExp && maxExp) {
    const output = maxExp <= 1 ? `${maxExp} Year` : `${maxExp} Years`;
    return capitalizeFirstLetter(output);
  }
};

export const formatExperienceYearAndMonth = (totalExpYears, totalExpMonths) => {
  // Handle the case when both years and months are 0
  if (totalExpYears == 0 && totalExpMonths == 0) {
    return "0 Year";
  }

  let formattedString = "";

  if (totalExpYears > 0) {
    formattedString += `${totalExpYears} Year${totalExpYears > 1 ? "s" : ""}`;
  }

  if (totalExpMonths > 0) {
    if (totalExpYears > 0) {
      formattedString += " ";
    }
    formattedString += `${totalExpMonths} Month${totalExpMonths > 1 ? "s" : ""
      }`;
  }

  return formattedString.trim();
};

export const convertMonthsToYears = (months) => {
  if (months === null || months === undefined || months === "") {
    return 0;
  }
  const num = Number(months);
  if (isNaN(num) || num < 0) {
    return 0;
  }
  if (num >= 12) {
    return Math.floor(num / 12);
  }
  return num;
};

export function convertMonthsToYearsDecimal(months) {
  // Ensure the input is a number and is not negative
  if (months < 0) {
    return "0 ";
  }

  // Calculate years and decimal months
  const years = Math.floor(months / 12);
  const decimalMonths = ((months % 12) / 12).toFixed(2); // Get months as a decimal of a year

  // Combine years and decimal months
  const result = (years + parseFloat(decimalMonths)).toFixed(1);

  return `${result} `;
}

export const convertMonthsToYearsAndMonths = (months) => {
  // Ensure the input is a number and is not negative
  if (months < 0) {
    return "0 months";
  }

  // Calculate years and remaining months
  const years = Math.floor(months / 12);
  const remainingMonths = months % 12;

  // Construct the result string based on the values
  let result = "";
  if (years > 0) {
    result += `${years} year${years > 1 ? "s" : ""}`;
  }
  if (remainingMonths > 0) {
    result += ` ${remainingMonths} month${remainingMonths > 1 ? "s" : ""}`;
  }

  return result.trim();
};

export const generateSlug = (...parts) => {
  return parts
    .filter((part) => part !== null && part !== undefined) // Filter out null or undefined parts
    .map(
      (part) =>
        part
          .toString() // Convert part to string
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-") // Replace non-alphanumeric characters with hyphens
          .replace(/^-+|-+$/g, "") // Remove leading and trailing hyphens
    )
    .join("-");
};

export const extractAfterLastHyphen = (str, positionFromEnd = 1) => {
  if (typeof str !== "string") {
    return null;
  }

  const parts = str.split("-");
  if (positionFromEnd <= parts.length) {
    return parts[parts.length - positionFromEnd];
  }
  return null;
};

// localStorageUtils.js
export const loadFiltersFromLocalStorage = (key, defaultFilters) => {
  const storedFilters = localStorage.getItem(key);
  return storedFilters ? JSON.parse(storedFilters) : defaultFilters;
};

export const saveFiltersToLocalStorage = (key, filters) => {
  localStorage.setItem(key, JSON.stringify(filters));
};

export const removeFiltersFromLocalStorage = (key) => {
  localStorage.removeItem(key);
};

// CommonFunctions.js
export function idToBase64(id) {
  const idString = String(id); // Convert ID to a string explicitly
  return btoa(idString);
}

// CommonFunctions.js
export function base64ToId(base64String) {
  const decodedString = atob(base64String);
  return parseInt(decodedString, 10); // Convert decoded string to integer
}

export const formatNumberWithCommas = (num) => {
  // Convert the number to string
  let str = num.toString();

  // Split the integer part and the decimal part if any
  let [integerPart, decimalPart] = str.split(".");

  // For the integer part, we will apply the Indian formatting
  let lastThreeDigits = integerPart.slice(-3);
  let otherDigits = integerPart.slice(0, -3);

  // Format the number in Indian style
  if (otherDigits !== "") {
    lastThreeDigits = "," + lastThreeDigits;
  }

  let formattedInteger =
    otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThreeDigits;

  // Combine the formatted integer part with the decimal part, if exists
  if (decimalPart) {
    return formattedInteger + "." + decimalPart;
  } else {
    return formattedInteger;
  }
};

// Utility function to validate number input and convert to words
export const convertNumberToWords = (price) => {
  const sglDigit = [
    "Zero",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const dblDigit = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tensPlace = [
    "",
    "Ten",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  const handle_tens = (dgt, prevDgt) => {
    return dgt === 0
      ? ""
      : dgt === 1
        ? ` ${dblDigit[prevDgt]}`
        : ` ${tensPlace[dgt]}`;
  };

  const handle_utlc = (dgt, nxtDgt, denom) => {
    return (
      (dgt !== 0 && nxtDgt !== 1 ? ` ${sglDigit[dgt]}` : "") +
      (nxtDgt !== 0 || dgt > 0 ? ` ${denom}` : "")
    );
  };

  let str = "";
  let words = [];

  price = price.toString();

  if (isNaN(parseInt(price))) {
    return "";
  } else if (parseInt(price) === 0) {
    return sglDigit[0]; // Return "Zero" if price is 0
  } else if (parseInt(price) > 0 && price.length <= 10) {
    for (let digitIdx = price.length - 1; digitIdx >= 0; digitIdx--) {
      let digit = price[digitIdx] - 0;
      let nxtDigit = digitIdx > 0 ? price[digitIdx - 1] - 0 : 0;
      let place = price.length - digitIdx - 1;

      switch (place) {
        case 0:
          words.push(handle_utlc(digit, nxtDigit, ""));
          break;
        case 1:
          words.push(handle_tens(digit, price[digitIdx + 1]));
          break;
        case 2:
          words.push(
            digit !== 0
              ? ` ${sglDigit[digit]} Hundred${price[digitIdx + 1] !== "0" && price[digitIdx + 2] !== "0"
                ? " and"
                : ""
              }`
              : ""
          );
          break;
        case 3:
          words.push(handle_utlc(digit, nxtDigit, "Thousand"));
          break;
        case 4:
          words.push(handle_tens(digit, price[digitIdx + 1]));
          break;
        case 5:
          words.push(handle_utlc(digit, nxtDigit, "Lakh"));
          break;
        case 6:
          words.push(handle_tens(digit, price[digitIdx + 1]));
          break;
        case 7:
          words.push(handle_utlc(digit, nxtDigit, "Crore"));
          break;
        case 8:
          words.push(handle_tens(digit, price[digitIdx + 1]));
          break;
        case 9:
          words.push(
            digit !== 0
              ? ` ${sglDigit[digit]} Hundred${price[digitIdx + 1] !== "0" || price[digitIdx + 2] !== "0"
                ? " and"
                : " Crore"
              }`
              : ""
          );
          break;
        default:
          break;
      }
    }
    str = words.reverse().join("");
  } else {
    str = "";
  }

  return str.trim();
};

export const formatWebsite = (website) => {
  // Remove "https://" and "http://"
  website = website.replace(/^https?:\/\//, "");

  // Remove leading "www." (if present)
  website = website.replace(/^www\./, "");

  // Remove any unwanted characters (e.g., hash (#), query params, spaces, etc.)
  website = website.replace(/[#?].*$/, ""); // This removes the hash and query params

  // Remove trailing slash if present
  website = website.replace(/\/$/, ""); // Remove the trailing slash

  // Ensure presence of "www."
  website = `www.${website}`;

  return website;
};

export const countryPhoneLengthMap = {
  1: 10,   // United States, Canada
  7: 11,   // Russia, Kazakhstan
  20: 10,  // Egypt
  27: 10,  // South Africa
  30: 10,  // Greece
  31: 9,   // Netherlands
  32: 9,   // Belgium
  33: 10,  // France
  34: 9,   // Spain
  36: 9,   // Hungary
  39: 10,  // Italy (mobile)
  40: 10,  // Romania
  41: 12,  // Switzerland
  43: 13,  // Austria
  44: 10,  // United Kingdom
  45: 8,   // Denmark
  46: 10,  // Sweden
  47: 8,   // Norway
  48: 9,   // Poland
  49: 11,  // Germany
  51: 9,   // Peru
  52: 10,  // Mexico
  53: 8,   // Cuba
  54: 10,  // Argentina
  55: 11,  // Brazil
  56: 9,   // Chile
  57: 10,  // Colombia
  58: 10,  // Venezuela
  60: 10,  // Malaysia
  61: 9,   // Australia
  62: 10,  // Indonesia
  63: 10,  // Philippines
  64: 9,   // New Zealand
  65: 8,   // Singapore
  66: 9,   // Thailand
  81: 10,  // Japan
  82: 11,  // South Korea
  84: 10,  // Vietnam
  86: 11,  // China
  90: 10,  // Turkey
  91: 10,  // India
  92: 10,  // Pakistan
  93: 9,   // Afghanistan
  94: 10,  // Sri Lanka
  95: 9,   // Myanmar
  98: 10,  // Iran
  211: 9,  // South Sudan
  212: 9,  // Morocco
  213: 9,  // Algeria
  216: 8,  // Tunisia
  218: 10, // Libya
  220: 7,  // Gambia
  221: 9,  // Senegal
  222: 8,  // Mauritania
  223: 8,  // Mali
  224: 9,  // Guinea
  225: 8,  // Ivory Coast
  226: 8,  // Burkina Faso
  227: 8,  // Niger
  228: 8,  // Togo
  229: 8,  // Benin
  230: 8,  // Mauritius
  231: 9,  // Liberia
  232: 8,  // Sierra Leone
  233: 9,  // Ghana
  234: 10, // Nigeria
  235: 8,  // Chad
  236: 8,  // Central African Republic
  237: 9,  // Cameroon
  238: 7,  // Cape Verde
  239: 7,  // São Tomé and Príncipe
  240: 9,  // Equatorial Guinea
  241: 9,  // Gabon
  242: 9,  // Republic of the Congo
  243: 9,  // Democratic Republic of the Congo
  244: 9,  // Angola
  245: 7,  // Guinea-Bissau
  246: 7,  // British Indian Ocean Territory
  248: 7,  // Seychelles
  249: 9,  // Sudan
  250: 9,  // Rwanda
  251: 9,  // Ethiopia
  252: 8,  // Somalia
  253: 8,  // Djibouti
  254: 10, // Kenya
  255: 9,  // Tanzania
  256: 9,  // Uganda
  257: 8,  // Burundi
  258: 9,  // Mozambique
  260: 9,  // Zambia
  261: 9,  // Madagascar
  262: 9,  // Réunion
  263: 9,  // Zimbabwe
  264: 9,  // Namibia
  265: 9,  // Malawi
  266: 8,  // Lesotho
  267: 7,  // Botswana
  268: 8,  // Eswatini (Swaziland)
  269: 7,  // Comoros
  290: 7,  // Saint Helena
  291: 7,  // Eritrea
  297: 7,  // Aruba
  298: 6,  // Faroe Islands
  299: 6,  // Greenland
  350: 8,  // Gibraltar
  351: 9,  // Portugal
  352: 9,  // Luxembourg
  353: 9,  // Ireland
  354: 7,  // Iceland
  355: 9,  // Albania
  356: 8,  // Malta
  357: 8,  // Cyprus
  358: 10, // Finland
  359: 9,  // Bulgaria
  370: 8,  // Lithuania
  371: 8,  // Latvia
  372: 7,  // Estonia
  373: 8,  // Moldova
  374: 8,  // Armenia
  375: 9,  // Belarus
  376: 6,  // Andorra
  377: 8,  // Monaco
  378: 10, // San Marino
  380: 9,  // Ukraine
  381: 9,  // Serbia
  382: 8,  // Montenegro
  383: 8,  // Kosovo
  385: 9,  // Croatia
  386: 8,  // Slovenia
  387: 8,  // Bosnia and Herzegovina
  389: 8,  // North Macedonia
  420: 9,  // Czech Republic
  421: 9,  // Slovakia
  423: 7,  // Liechtenstein
  500: 5,  // Falkland Islands
  501: 7,  // Belize
  502: 8,  // Guatemala
  503: 8,  // El Salvador
  504: 8,  // Honduras
  505: 8,  // Nicaragua
  506: 8,  // Costa Rica
  507: 8,  // Panama
  508: 6,  // Saint Pierre and Miquelon
  509: 8,  // Haiti
  591: 8,  // Bolivia
  592: 7,  // Guyana
  593: 9,  // Ecuador
  594: 9,  // French Guiana
  595: 9,  // Paraguay
  597: 7,  // Suriname
  598: 9,  // Uruguay
  880: 10, // Bangladesh
  886: 9,  // Taiwan
  960: 7,  // Maldives
  961: 8,  // Lebanon
  962: 8,  // Jordan
  963: 9,  // Syria
  964: 10, // Iraq
  965: 8,  // Kuwait
  966: 9,  // Saudi Arabia
  967: 8,  // Yemen
  968: 9,  // Oman
  970: 9,  // Palestinian Territories
  971: 9,  // UAE
  972: 9,  // Israel
  973: 8,  // Bahrain
  974: 8,  // Qatar
};



export const convertFileToPdf = async (file, candidateName) => {
  // const apiUrl = "https://api.indiagethired.com/convertHtmlToPdf";
  const apiUrl = "https://api-test.xyntara.in/convertHtmlToPdf";

  try {
    // Create a FormData object to hold the file
    const formData = new FormData();
    formData.append("file", file); // Add the HTML file
    console.log("file44", file);
    console.log("formData555", formData);
    // Send the file to the server using FormData
    const response = await fetch(apiUrl, {
      method: "POST",
      body: formData, // Send FormData instead of JSON
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;

    // Set the download filename with the candidate's name
    const sanitizedCandidateName = candidateName.replace(/\s+/g, "_");
    link.download = `NF_${sanitizedCandidateName}.pdf`; // Specify the download filename
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Failed to convert HTML to PDF:", error);
  }
};

// export const convertFileToPdf = async (file, candidateName) => {
//   const apiUrl = "http://localhost:8080/convertHtmlToPdf";

//   try {
//     const formData = new FormData();
//     formData.append("file", file);

//     console.log("Sending file:", file);

//     const response = await fetch(apiUrl, {
//       method: "POST",
//       body: formData,
//       credentials: "include", // 🔥 IMPORTANT
//     });

//     if (!response.ok) {
//       const text = await response.text();
//       console.error("Server error response:", text);
//       throw new Error(`Error: ${response.status}`);
//     }

//     const blob = await response.blob();

//     const blobUrl = window.URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = blobUrl;

//     const sanitizedCandidateName = candidateName.replace(/\s+/g, "_");
//     link.download = `NF_${sanitizedCandidateName}.pdf`;

//     document.body.appendChild(link);
//     link.click();
//     link.remove();

//     window.URL.revokeObjectURL(blobUrl);
//   } catch (error) {
//     console.error("Failed to convert HTML to PDF:", error);
//   }
// };

// utils/validation.js
// export const handleNumberInput = (e, handleChange, min, max) => {
//   const value = e.target.value;
//   // Allow empty input or ensure the value is a valid number within the range
//   if (value === ""  || (value >= min && value <= max)) {
//     handleChange(e); // Call your existing handleChange function
//   }
// };

// export const handleNumberInput = (e, handleChange, min, max, isInd = false) => {
//   const value = e.target.value;

//   // If isInd is false (i.e., decimals not allowed), reject if value includes "."
//   const hasDecimal = value.includes(".");

//   if (!isInd && hasDecimal) {
//     return; // Block input if decimals are not allowed
//   }

//   const numberValue = isInd ? parseFloat(value) : parseInt(value);

//   // Check for empty input or number within range
//   const isValidNumber = value === "" || (numberValue >= min && numberValue <= max);

//   // Reject leading zeros when min is 0 and decimals aren't allowed
//   const hasLeadingZero = !isInd && min === 0 && value.length > 1 && value.startsWith("0");

//   if (isValidNumber && !hasLeadingZero) {
//     handleChange(e);
//   }
// };

export const handleNumberInput = (e, handleChange, min, max, isInd = false) => {
  let value = e.target.value;

  // Strip non-numeric characters (allow decimal point only if isInd is true)
  if (!isInd) {
    value = value.replace(/[^0-9]/g, "");
  } else {
    value = value.replace(/[^0-9.]/g, "");
    // Ensure only one decimal point exists
    const parts = value.split(".");
    if (parts.length > 2) {
      value = parts[0] + "." + parts.slice(1).join("");
    }
  }

  // Allow clearing the field
  if (value === "") {
    e.target.value = "";
    handleChange(e);
    return;
  }

  // Handle leading zeros
  if (!isInd) {
    if (min === 0) {
      if (/^0{2,}/.test(value)) {
        value = "0";
      } else if (/^0[1-9]+/.test(value)) {
        value = value.replace(/^0+/, "");
      }
    } else {
      value = value.replace(/^0+/, "");
      if (value === "") {
        e.target.value = "";
        handleChange(e);
        return;
      }
    }
  }

  e.target.value = value;

  const numericValue = isInd ? parseFloat(value) : parseInt(value, 10);

  if (isNaN(numericValue)) {
    e.target.value = "";
    handleChange(e);
    return;
  }

  // Cap at max if specified
  if (max !== undefined && max !== null && numericValue > max) {
    value = max.toString();
    e.target.value = value;
    handleChange(e);
    return;
  }

  // Reset if below min
  if (min !== undefined && min !== null && numericValue < min) {
    e.target.value = "";
    handleChange(e);
    return;
  }

  handleChange(e);
};









export default CommonFunction;
